export default {"src":"/_next/static/media/HyperLogo.8b057f2f.svg","height":193,"width":193};